import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HeadersService } from '../headers/headers.service';
import { firstValueFrom, Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { DbPrompt, Prompt } from '../../../../models/prompt';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ApiPromptsService {
  constructor(
    private http: HttpClient,
    private headersService: HeadersService
  ) {}

  retrievePrompts(): Observable<Prompt[]> {
    return this.http
      .post<DbPrompt>(
        `${environment.explainApiUrl}prompts`,
        { filters: { user_id: localStorage.getItem('user_id') }, limit: 1000 },
        this.headersService.httpHeaders
      )
      .pipe(
        map((data: any) => {
          return data['data'].map((dbPrompt: DbPrompt) => {
            return new Prompt(dbPrompt);
          });
        })
      );
  }

  upsertPrompt(title: string, prompt: string, promptId?: number): Promise<{ prompt_id: number }> {
    return firstValueFrom(
      this.http.put<{ prompt_id: number }>(
        `${environment.explainApiUrl}prompts`,
        {
          title: title,
          text: prompt,
          id: promptId,
        },
        this.headersService.httpHeaders
      )
    );
  }

  deletePrompt(id: number): Promise<any> {
    return firstValueFrom(this.http.delete<any>(`${environment.explainApiUrl}prompts?id=${id}`, this.headersService.httpHeaders));
  }
}
